/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from "react";
import {
  CityProps,
  StateProps,
} from "../../../../../domain/models/address.model";
import { CNAESModel } from "../../../../../domain/models/cnae";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { EconomicActivityModel } from "../../../../../domain/models/economic-activity";
import { FilterModel } from "../../../../../domain/models/enum";
import { TakerModel } from "../../../../../domain/models/taker";
import { makeRemoteEconomicActivity } from "../../../../../main/factories/usecases/activity-economic/remote-activity-economic-factory";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import ButtonComponent from "../../../../components/button";
import ButtonRound from "../../../../components/button-action";
import { ItemField } from "../../../../components/datagrid";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import Icons from "../../../../components/icons-helper";
import { theme } from "../../../../styles/theme";
import CNAESComponent from "./cnaes";
import { ContainerButtonActions } from "./styles";
import TomadorComponent from "./tomador";

export const FilterFields = (setParams: any): GroupProp[] => {
  const [values, setValues] = useState<string>("");
  return [
    {
      groupName: "FILTER",
      // groupLabel: 'Tomador:',
      items: [
        {
          name: "socialReason",
          type: "text",
          label: "Nome:",
          onChange: (e) => {
            setValues(e);
          },
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorSearch",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Pesquisar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({
                    ...prev,
                    filters: `socialReason~${values}`,
                  }))
                }
              />
            </div>
          ),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorClear",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Limpar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({ ...prev, filters: null }))
                }
              />
            </div>
          ),
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};
export const Fields = (
  cnaesList: CNAESModel[],
  developerCompaniesList: DeveloperCompanyModel[],
  currentNote: any,
  setCurrentNote: any,
): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);
  const [companySelected, setCompanySelected] = useState<number>();
  const [aliquotIssRequired, setAliquotIssRequired] = useState<boolean>();
  const [activities, setActivities] = useState<EconomicActivityModel[]>([]);
  const [economicActivitySelected, setEconomicActivitySelected] =
    useState<number>();
  // const [documentType, setDocumentType] = useState<'CPF' | 'CNPJ'|'none'>('CPF')
  const [iss, setIss] = useState<boolean>(false);
  const [hasRecurrence, setHasRecurrence] = useState<boolean>(false);
  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  const loadActivities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const response = await makeRemoteEconomicActivity().loadByCNAE(initial);
      setActivities(response);
    })();
  };

  useEffect(() => {
    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, []);
  return [
    {
      groupName: "TOMADOR",
      groupLabel: "Prestador:",
      items: [
        {
          name: "company",
          type: "select",
          validations: "inputRequired",
          label: "Selecione a empresa que prestou o serviço*:",
          onChange: (e: any) => {
            setCompanySelected(e.value);
          },
          options: developerCompaniesList?.map((el) => ({
            value: el?.id,
            label: el.company?.socialReason,
          })),
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        {
          name: "tomador",
          type: "component",
          component: (): JSX.Element => (
            <TomadorComponent
              setCurrentNote={setCurrentNote}
              currentNote={currentNote}
            />
          ),
        },
      ],
    },
    {
      groupName: "ISSUE",
      groupLabel: "Dados da nota fiscal: ",
      items: [
        {
          name: "competencia",
          type: "date",
          label: "Competência*: ",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "emissionDate",
          type: "text",
          label: "Data de Emissão:",
          disabled: true,
          defaultValue: new Date().toLocaleDateString(),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "SERVICE",
      groupLabel: "Dados do Serviço:",
      items: [
        {
          name: "description",
          type: "textarea",
          label: "Discriminação do(s) serviço(s) prestado(s)*:",
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "none", label: "Não Existe" },
          ],
          validations: "inputRequired",
          rows: 6,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "cnaes",
          type: "select",
          label: "Atividade Econômica do Prestador(CNAE)*:",
          validations: "inputRequired",
          placeholder: "00000 - Exemplo",
          onChange: (e: any) => {
            loadActivities(e.value);
          },
          options: cnaesList.map((el) => ({
            ...el,
            value: el?.id,
            label: `${el?.code} - ${el.description}${
              el?.cityPattern?.name && el?.cityPattern?.state?.initials
                ? ` (${el.cityPattern.name} - ${el.cityPattern.state.initials})`
                : ""
            }`,
          })),
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "addCNAES",
          type: "component",
          component: (): JSX.Element => (
            <CNAESComponent setCurrentNote={setCurrentNote} />
          ),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "activityEconomy",
          type: "select",
          label: "Atividade de atuação do Prestador no município*:",
          onChange: (e: any) => {
            setEconomicActivitySelected(e.value);
          },
          options: activities.map((el) => ({
            value: el?.id,
            label: el.description,
            aliquot: el.aliquot,
          })),
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    {
      groupName: "SERVICE",
      groupLabel: "Local da prestação do serviço:",
      items: [
        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "inputRequired",
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({
            value: el?.id,
            label: el.initials,
          })),
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "inputRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "VALUES",
      groupLabel: "Valores:",
      items: [
        {
          name: "serviceValue",
          type: "currency",
          label: "Valor do(s) serviço(s)*:",
          placeholder: "0,00",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "unconditionalDiscount",
          type: "currency",
          disabled: false,
          label: "Desconto Incondicionado:",
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "conditionedDiscount",
          type: "currency",
          disabled: false,
          label: "Desconto Condicionado:",
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "dedution",
          type: "currency",
          disabled: true,
          label: "Valor das deduções*:",
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },

        {
          name: "totalValue",
          type: "currency",
          disabled: true,
          label: "Valor da Nota:",
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "iss",
          type: "radio",
          label: "ISS Retido*:",
          onChange(val) {
            const company = developerCompaniesList.find(
              (item) => item.id === companySelected,
            );
            setAliquotIssRequired(company?.company?.simpleNacional);
            setIss(val === "true");
          },
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "issAliquot",
          type: "currency",
          hide: !iss,
          defaultValue:
            !aliquotIssRequired && economicActivitySelected
              ? `${
                  activities.find(
                    (item) => item.id === economicActivitySelected,
                  )?.aliquot
                }`
              : "",
          disabled: !aliquotIssRequired,
          label: "Alíquota:",
          placeholder: "0,00",
          validations: iss && aliquotIssRequired ? "inputRequired" : "",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "otherDeductions",
          type: "currency",
          disabled: false,
          label: "Outras deduções:",
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "RECURRENCE",
      groupLabel: "Recorrência:",
      items: [
        {
          name: "hasRecurrence",
          type: "radio",
          label: "Gerar nota de forma recorrente*:",
          onChange(val) {
            console.log(hasRecurrence);
            setHasRecurrence(val === "true");
          },
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
  ];
};

export const FieldsTomador = (
  data: TakerModel | null | undefined,
): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);
  const [docType, setDocType] = useState<"CNPJ" | "CPF">("CPF");

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    const defaultState = data?.address?.city?.state?.id;
    if (defaultState) {
      loadCities(defaultState);
    }

    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, [data]);

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        {
          name: "documentTypeEnum",
          type: "radio",
          defaultValue: data?.documentTypeEnum || "CPF",
          label: "Documento*",
          onChange: (e) => {
            setDocType(e);
          },
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "NONE", label: "Não Existe" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "documentNumber",
          type: "text",
          label: "CPF/CNPJ:",
          defaultValue: data?.documentNumber,
          placeholder:
            docType === "CPF" ? "000.000.000-00" : "00. 000. 000/0001-00",
          mask: docType === "CPF" ? "000.000.000-00" : "00. 000. 000/0001-00",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "municipalRegistration",
          type: "text",
          label: "Inscrição Municipal:",
          defaultValue: data?.municipalRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "stateRegistration",
          type: "text",
          label: "Inscrição Estadual:",
          defaultValue: data?.stateRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "socialReason",
          type: "text",
          label: "Razão Social/Nome*:",
          defaultValue: data?.socialReason,
          placeholder: "0000000000000000000000",
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "zipCode",
          type: "text",
          label: "CEP:",
          mask: "00000-000",
          validations: "inputRequired",
          defaultValue: data?.address?.zipCode,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        // {
        //   name: 'addressType',
        //   type: 'select',
        //   validations: 'objectRequired',
        //   label: 'Tipo de Endereço:',
        //   defaultValue: Number(addressTypeList?.find(
        //     (el) => el.ENUM === data?.address?.addressType,
        //   )?.value),
        //   options: addressTypeList,
        //   col: {
        //     xs: 4,
        //     md: 4,
        //     lg: 4,
        //   },
        // },
        {
          name: "address",
          type: "text",
          label: "Endereço",
          validations: "inputRequired",
          defaultValue: data?.address?.place,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "number",
          type: "text",
          label: "Número:",
          validations: "inputRequired",
          defaultValue: data?.address?.number,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "district",
          type: "text",
          label: "Bairro:",
          validations: "inputRequired",
          defaultValue: data?.address?.district,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complement",
          type: "text",
          label: "Complemento:",
          defaultValue: data?.address?.complement,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "objectRequired",
          defaultValue: data?.address?.city?.state?.id,
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "objectRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          defaultValue: data?.address?.city?.id,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "email",
          type: "text",
          label: "E-mail:",
          validations: "emailRequired",
          defaultValue: data?.email,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "taxSubstitute",
          type: "radio",
          defaultValue: `${data?.taxSubstitute}`,
          label: "Substituto Tributária*",
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
      ],
    },
  ];
};
export const FieldsCNAES = (): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, []);

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "CNAE:",
      items: [
        {
          name: "code",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "description",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },

        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "inputRequired",
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "inputRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "Activity",
      groupLabel: "Atividade Econômica:",
      items: [
        {
          name: "codeActivity",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "descriptionActivity",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "aliquot",
          type: "number",
          label: "Aliquota:",
          validations: "inputRequired",
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};

export const fieldsGrid = (
  setShow: any,
  setShowGrid: any,
  setSelected: any,
): ItemField[] => [
  {
    title: "Documento",
    key: "id",
    renderItem: (data: TakerModel) => data.documentNumber,
  },
  {
    title: "Nome",
    key: "createdAt",
    renderItem: (data: TakerModel) => data.socialReason,
  },
  {
    title: "",
    key: "actions",
    renderItem: (data) => (
      <ContainerButtonActions>
        <ButtonRound
          backgroundColor={theme.colors.white}
          onClick={() => {
            setSelected(data);
            setShowGrid(false);
            setShow(true);
          }}
        >
          <Icons
            height={25}
            width={25}
            name="edit"
            color={theme.colors.primary}
          />
        </ButtonRound>
      </ContainerButtonActions>
    ),
  },
];
